import { UserRole } from '@shared/types/user';
import { ROUTES } from './routes';

/**
 * Get the default redirect route based on user role
 */
export function getDefaultRouteForRole(role: UserRole): string {
  const roleRouteMap: Record<UserRole, string> = {
    [UserRole.ADMIN]: ROUTES.ADMIN.BASE,
    [UserRole.PARTNER]: ROUTES.PARTNER.BASE,
    [UserRole.USER]: ROUTES.CUSTOMER.SEARCH,
  };

  return roleRouteMap[role] || ROUTES.CUSTOMER.SEARCH;
}

